import { Input } from "src/features/calculator/types/formula"

const TRANSFER_COUNT_THRESHOLD = 10
const HIGH_FEE_RATE = 0.6 // 同月の総客数が閾値を超えた場合の手数料率
const LOW_FEE_RATE = 0.55 // 閾値以下の場合の手数料率
// 送客手数料率(税抜) もし同月の総客数が>10ならば0.6。それ以外は0.55
export function calcExCustomerTransferFeeRate({ monthlyTransferCount }: Input): number {
  return monthlyTransferCount > TRANSFER_COUNT_THRESHOLD ? HIGH_FEE_RATE : LOW_FEE_RATE
}

// 立替金送金額 = 立替元本
export function calcRemittance({ totalReimbursement }: Input): number {
  return totalReimbursement
}
